import { RuleListStatus } from '../../types';
export const getNextRuleAndGroup = (ruleGroups, currentGroup, currentRule) => {
  if (!ruleGroups || !currentGroup || !currentRule) {
    return {
      nextGroup: null,
      nextRule: null
    };
  }
  const updatedCurrentGroup = ruleGroups.find(group => group.groupId === currentGroup.groupId);
  const updatedCurrentRule = updatedCurrentGroup == null ? void 0 : updatedCurrentGroup.ruleResults.find(rule => rule.id === currentRule.id);
  if (!updatedCurrentGroup || !updatedCurrentRule) {
    return {
      nextGroup: null,
      nextRule: null
    };
  }
  if (updatedCurrentRule.status === RuleListStatus.failed) {
    return {
      nextGroup: currentGroup,
      nextRule: currentRule
    };
  }
  const currentRuleIndex = updatedCurrentGroup.ruleResults.findIndex(rule => rule.id === currentRule.id);
  const nextFailedRule = updatedCurrentGroup.ruleResults.slice(currentRuleIndex + 1).find(rule => rule.status === RuleListStatus.failed);
  if (nextFailedRule) {
    return {
      nextGroup: currentGroup,
      nextRule: nextFailedRule
    };
  }
  const hasFailedRulesBefore = updatedCurrentGroup.ruleResults.slice(0, currentRuleIndex).some(rule => rule.status === RuleListStatus.failed);
  if (hasFailedRulesBefore) {
    return {
      nextGroup: currentGroup,
      nextRule: null
    };
  }
  if (updatedCurrentRule.status === RuleListStatus.passed) {
    return {
      nextGroup: currentGroup,
      nextRule: null
    };
  }
  return {
    nextGroup: null,
    nextRule: null
  };
};
//# sourceMappingURL=get-next-rule-and-group.js.map